var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 151,
    viewBox: "0 0 127 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.3757 43.3281C94.3757 43.3281 98.4376 103.67 61.8858 103.67C25.3353 103.67 28.2689 43.3281 28.2689 43.3281C28.2689 43.3281 26.5034 7.44313 63.1246 7.44313C97.2073 7.44313 94.3757 43.3281 94.3757 43.3281Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3654 55.2352C94.3654 55.2352 97.7874 50.2981 101.847 52.6932C105.907 55.0868 104.614 63.9267 101.847 68.348C99.0786 72.7679 94.6104 74.9524 92.1398 71.5584",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3654 55.2352C94.3654 55.2352 97.7874 50.2981 101.847 52.6932C105.907 55.0868 104.614 63.9267 101.847 68.348C99.0786 72.7679 94.6104 74.9524 92.1398 71.5584",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.402 58.2187C101.402 58.2187 96.8277 56.6954 93.5813 63.4186",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8019 60.129C95.8019 60.129 100.78 62.7869 97.4909 66.7801",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 55.2352C28.5137 55.2352 25.0917 50.2981 21.0326 52.6932C16.9735 55.0868 18.2647 63.9267 21.0326 68.348C23.8005 72.7679 28.2688 74.9524 30.7408 71.5584",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 55.2352C28.5137 55.2352 25.0917 50.2981 21.0326 52.6932C16.9735 55.0868 18.2647 63.9267 21.0326 68.348C23.8005 72.7679 28.2688 74.9524 30.7408 71.5584",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4769 58.2187C21.4769 58.2187 26.0514 56.6954 29.2993 63.4186",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.078 60.129C27.078 60.129 22.1 62.7869 25.3889 66.7801",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7314 54.0989V66.7496C59.7314 67.1424 59.8079 67.5197 59.9466 67.8659C60.4903 69.2238 62.0562 69.8738 63.472 69.4979L66.516 68.6897",
    stroke: "#1A1A1A",
    strokeWidth: 1.52662,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8133 34.0399C56.5486 34.4355 54.96 39.4531 54.96 39.4531H37.4989L43.4269 36.0986C44.929 35.3483 46.5615 34.8919 48.2364 34.752L56.8133 34.0399Z",
    fill: "#1A1A1A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8203 34.0399C68.0851 34.4355 69.6736 39.4531 69.6736 39.4531H87.1347L81.2068 36.0986C79.7046 35.3483 78.0722 34.8919 76.3973 34.752L67.8203 34.0399Z",
    fill: "#1A1A1A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0761 51.3493C51.0761 53.0195 49.7197 54.3746 48.0448 54.3746C46.3714 54.3746 45.015 53.0195 45.015 51.3493C45.015 49.6791 46.3714 48.324 48.0448 48.324C49.7197 48.324 51.0761 49.6791 51.0761 51.3493Z",
    fill: "#1A1A1A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3183 51.3493C79.3183 53.0195 77.9619 54.3746 76.287 54.3746C74.6135 54.3746 73.2572 53.0195 73.2572 51.3493C73.2572 49.6791 74.6135 48.324 76.287 48.324C77.9619 48.324 79.3183 49.6791 79.3183 51.3493Z",
    fill: "#1A1A1A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.903 75.7212C51.903 75.7212 56.8823 79.1902 62.9151 79.1902C68.9492 79.1902 73.1174 75.7212 73.1174 75.7212",
    stroke: "#1A1A1A",
    strokeWidth: 1.52662,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7722 52.1386C57.7722 59.1444 52.0806 64.8247 45.0611 64.8247C38.0415 64.8247 32.35 59.1444 32.35 52.1386C32.35 45.1329 38.0415 39.4526 45.0611 39.4526C52.0806 39.4526 57.7722 45.1329 57.7722 52.1386Z",
    fill: "url(#paint0_diamond_32_1387)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7722 52.1386C57.7722 59.1444 52.0806 64.8247 45.0611 64.8247C38.0415 64.8247 32.35 59.1444 32.35 52.1386C32.35 45.1329 38.0415 39.4526 45.0611 39.4526C52.0806 39.4526 57.7722 45.1329 57.7722 52.1386Z",
    fill: "url(#paint1_diamond_32_1387)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7722 52.1386C57.7722 59.1444 52.0806 64.8247 45.0611 64.8247C38.0415 64.8247 32.35 59.1444 32.35 52.1386C32.35 45.1329 38.0415 39.4526 45.0611 39.4526C52.0806 39.4526 57.7722 45.1329 57.7722 52.1386Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9986 52.1386C88.9986 59.1444 83.3071 64.8247 76.2875 64.8247C69.2665 64.8247 63.5764 59.1444 63.5764 52.1386C63.5764 45.1329 69.2665 39.4526 76.2875 39.4526C83.3071 39.4526 88.9986 45.1329 88.9986 52.1386Z",
    fill: "url(#paint2_diamond_32_1387)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9986 52.1386C88.9986 59.1444 83.3071 64.8247 76.2875 64.8247C69.2665 64.8247 63.5764 59.1444 63.5764 52.1386C63.5764 45.1329 69.2665 39.4526 76.2875 39.4526C83.3071 39.4526 88.9986 45.1329 88.9986 52.1386Z",
    fill: "url(#paint3_diamond_32_1387)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9986 52.1386C88.9986 59.1444 83.3071 64.8247 76.2875 64.8247C69.2665 64.8247 63.5764 59.1444 63.5764 52.1386C63.5764 45.1329 69.2665 39.4526 76.2875 39.4526C83.3071 39.4526 88.9986 45.1329 88.9986 52.1386Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7722 52.1386C57.7722 52.1386 60.7836 49.3338 63.577 52.1386",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8304 55.5561L28.3466 52.0377",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5432 55.5561L94.5108 50.8733",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3088 0.150177C16.7846 0.150177 21.2812 30.3916 28.053 54.3748C28.053 54.3748 34.0772 43.1935 32.8781 35.3047C58.1714 32.4306 80.8498 18.5208 80.963 18.4516C82.7116 32.237 94.6652 52.706 94.6652 52.706C101.402 30.3916 108.403 0.150177 61.3088 0.150177Z",
    fill: "#1A1A1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.038 181.445C147.038 149.858 110.442 131.382 110.442 131.382H66.5166H59.7307H15.8053C15.8053 131.382 -20.7904 149.858 -20.7904 181.445",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M147.038 181.445C147.038 149.858 110.442 131.382 110.442 131.382H66.5166H59.7307H15.8053C15.8053 131.382 -20.7904 149.858 -20.7904 181.445",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M135.3 151.531H-9.05127L-1.13833 143.333H127.387L135.3 151.531Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5471 93.244V118.609C39.5471 118.609 34.0891 128.219 15.8054 131.383H109.172C109.172 131.383 85.7575 126.515 84.0557 118.609V93.244",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5471 93.244V118.609C39.5471 118.609 34.0891 128.219 15.8054 131.383H109.172C109.172 131.383 85.7575 126.515 84.0557 118.609V93.244",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.038 91.9245C40.038 91.9245 46.6073 104.941 57.2358 110.986C64.9547 115.375 74.9361 113.672 80.1746 106.513C82.7868 102.94 84.7774 97.684 84.7774 89.9548C84.7774 89.9548 76.2656 101.14 63.5757 101.666C50.8873 102.192 40.038 91.9245 40.038 91.9245Z",
    fill: "#1A1A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_32_1387",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9491 51.9768) rotate(-98.5726) scale(12.6657 12.6896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_diamond_32_1387",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7059 47.4701) rotate(-125.148) scale(9.80535 9.81188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_diamond_32_1387",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.1547 47.4701) rotate(-62.7305) scale(9.02004 9.03037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_diamond_32_1387",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.1755 51.9768) rotate(-98.5726) scale(12.6657 12.6896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.38
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.5ad361e8b0b8b35d36c3b43550f8f25d.svg";
export { ForwardRef as ReactComponent };